import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DarkModeService } from '../../services/darkmode.service';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
    selector: 'app-accordion-faq-using-app',
    imports: [TranslateModule, CommonModule, MatExpansionModule],
    templateUrl: './accordion-faq-using-app.component.html',
    styleUrl: './accordion-faq-using-app.component.scss'
})
export class AccordionFaqUsingAppComponent {
  panelOpenState = false;
  darkMode = false;

  principalAccordion: {
    index: number;
    expanded: boolean;
  }[] = [
    {
      index: 0,
      expanded: false,
    },
    {
      index: 1,
      expanded: false,
    },
    {
      index: 2,
      expanded: false,
    },
    {
      index: 3,
      expanded: false,
    },
    {
      index: 4,
      expanded: false,
    },
    {
      index: 5,
      expanded: false,
    },
    {
      index: 6,
      expanded: false,
    },
    {
      index: 7,
      expanded: false,
    },
    {
      index: 8,
      expanded: false,
    },
    {
      index: 9,
      expanded: false,
    },
    {
      index: 10,
      expanded: false,
    },
  ];

  constructor(private darkmodeService: DarkModeService) {
    this.darkmodeService.isDarkMode.subscribe((isDark) => {
      this.darkMode = isDark;
    });
  }

  onExpandChange(index: number) {
    this.principalAccordion[index].expanded =
      !this.principalAccordion[index].expanded;
  }
}
